import * as types from './../constants/actionTypes';
import initialState from './initialState';

export default function (state = initialState.contacts, action) {
   switch (action.type) {
      case types.LOAD_ALL_CONTACTS_SUCCESS : {
         return action.payload.contacts;
      }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/contactReducers.js
 **/